<template>
  <van-cell class="ry-form__describe">
    <froalaView v-if="$store.getters.newRtf" v-model="content"></froalaView>
    <div v-else class="ql-container ql-snow">
      <div
        class="ql-editor"
        v-html="content">
      </div>
    </div>
  </van-cell>
</template>

<script>
  import { current } from './mixin'
  export default {
    mixins: [current],
    data () {
      return {}
    },
    computed: {
      content() {
        return this.current.content ||
          '<em style="color: rgb(136, 136, 136);">' +
          '描述文字内容' +
          '<span class="ql-cursor">&#65279;</span>' +
          '</em>'
      },
    },
    methods: {},
    components: {},
    watch: {}
  }
</script>



